import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { IStoreState } from "App/types";
import { clearActionMeta, authMetaSelector } from "Auth/state";
import { IAuthActions } from "Auth/types";

/*
  Custom hook to get the status, error and message for a specific authentication action.
  - The meta data of the authentication action is cleared when the component unmounts. 
*/
export const useStateActionMeta = (key: IAuthActions) => {
  const dispatch = useDispatch();
  const meta = useSelector((state: IStoreState) =>
    authMetaSelector(state, key)
  );

  useEffect(() => {
    return () => {
      dispatch(clearActionMeta(key));
    };
  }, [dispatch, key]);

  return meta;
};

/*
  Custom hook to get the status, error and message for a specific authentication action.
  - The meta data of the authentication action is cleared when the component MOUNTS. 
*/
export const useStateActionMetaOnMount = (
  key: IAuthActions,
  clearOnMount?: boolean
) => {
  const dispatch = useDispatch();
  const meta = useSelector((state: IStoreState) =>
    authMetaSelector(state, key)
  );

  // don't add deps, only clear action meta on mount
  useEffect(() => {
    if (!clearOnMount) return;

    dispatch(clearActionMeta(key));
  }, []); // eslint-disable-line

  return meta;
};
